<template>
  <el-container class="full-content">
    <!-- 移动端路由选择 -->
    <el-aside v-if="ShowMenu" class="user-aside user_show_Menu">
      <div class="user-aside-shadow">
        <div class="flex-col-center user-aside-top">
          <img :src="$Image(currentUser && currentUser.IsBoy === false ? 'head2_s.png' : 'head1_s.png')" alt="">
          <div style="margin-top:20px;">
            <el-select v-model="value" size="mini" @change="onChangeUser" placeholder='请选择'>
              <el-option
                v-for="item in deviceskids"
                :key="item.value"
                :label="item.NickName"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <el-table
            :data="asideTable"
            cell-class-name="aside-table-row"
            @row-click="onClickRow"
            style="width: 100%">
            <el-table-column>
              <template slot-scope="scope">
                <div class="flex-row-start aside-nav-item" :class="currentPath===scope.row.path ? 'aside-table-select' : 'aside-table-normal'">
                  <span class="shen_li" :class="currentPath===scope.row.path ? scope.row.selectIcon : scope.row.icon"></span>
                  <div>{{scope.row.label}}</div>
                  <img v-show="scope.row.proShow" :src="$Image('pro.png')" alt="" style="margin-left:10px">
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-aside>
    <!-- PC端路由选择 -->
    <el-aside class="user-aside user_hide_Menu" style="width:16%">
      <div class="user-aside-shadow">
        <div class="flex-col-center user-aside-top">
          <img :src="$Image(currentUser && currentUser.IsBoy === false ? 'head2_s.png' : 'head1_s.png')" alt="">
          <div style="margin-top:20px;">
            <el-select v-model="value" size="mini" @change="onChangeUser" placeholder='请选择'>
              <el-option
                v-for="item in deviceskids"
                :key="item.value"
                :label="item.NickName"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div>
          <el-table
            :data="asideTable"
            cell-class-name="aside-table-row"
            @row-click="onClickRow"
            style="width: 100%">
            <el-table-column>
              <template slot-scope="scope">
                <div class="flex-row-start aside-nav-item" :class="currentPath===scope.row.path ? 'aside-table-select' : 'aside-table-normal'">
                  <span class="shen_li" :class="currentPath===scope.row.path ? scope.row.selectIcon : scope.row.icon"></span>
                  <div>{{scope.row.label}}</div>
                  <img v-show="scope.row.proShow" :src="$Image('pro.png')" alt="" style="margin-left:10px">
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-aside>
     <el-main v-if="!isNoData" class="user-main" style="padding:2% 2% 0 2%;">
        <div class="syncSettingView">
          <el-dialog
            :title="$t('New Version Available')"
            :visible.sync="downloadApkDialog"
            :show-close = 'false'
            class="dialog-disconnect"
            style="border-radius: 20px;"
            center>
            <div>
              <div class="flex-row-between demo--dialog-body">
                <span v-if="this.activeDevice.OS === 'Android'" style="line-height:28px;">{{ $t('famiKit（ {ver} ）is now available for your kid. Please go toGoogle Play Store and install the latest version of Famikit on yourkid’s device', { ver: VersionApk }) }}</span>
                <span v-else style="line-height:28px;">{{ $t('famikit（ {ver} ）is now available for your kid. Please go to', { ver: VersionApk }) }}
                <a href="https://famikit.com/download.html" target="_blank">{{ $t('famikit.com') }}</a>
                <span>{{ $t('and install the latest version of Famikit for PC on yours device') }}</span>
                </span>
              </div>
              <div class="flex-row-end" style="margin-top:30px;">
                <span slot="footer" class="dialog-footer demo-dialog-footer">
                  <el-button class="delete-account-button" size="medium" round @click="downloadApkDialog = false">{{$t('No')}}</el-button>
                  <el-button class="delete-account-button" type="primary" round size="medium" @click="downloadNewVersion">{{$t('Yes')}}</el-button>
                </span>
              </div>
            </div>
          </el-dialog>
        </div>
        <div class="syncSettingView">
          <el-dialog
            :title="$t('Account expired')"
            :visible.sync="AccountExpired"
            :show-close = 'false'
            class="dialog-disconnect"
            style="border-radius: 20px;"
            center>
            <div>
              <div class="flex-row-between demo--dialog-body">
                <span style="line-height:28px;">{{ $t('Account expired Please renew!') }}</span>
              </div>
              <div class="flex-row-end" style="margin-top:30px;">
                <span slot="footer" class="dialog-footer demo-dialog-footer">
                  <el-button class="delete-account-button" size="medium" round @click="AccountExpired = false">{{$t('No')}}</el-button>
                  <el-button class="delete-account-button" type="primary" round size="medium" @click="AccountRenew">{{$t('Yes')}}</el-button>
                </span>
              </div>
            </div>
          </el-dialog>
        </div>
        <div class="tagStyle"
            v-if="isRefreshFailed"
              >
            <el-tag style="width:100%;height:50px;line-height:50px;"
                    type="success"
                    closable
                    @close="isRefreshFailed=false">{{$t('New data is uploading, it may take a while.')}}</el-tag>
        </div>
        <router-view/>
        <div class="item-view-footer">{{$t('Copyright @ 2020, Famikit.com. All rights reserved.')}}</div>
    </el-main>
    <div v-else class="flex-col-center nodata-wrap">
      <div class="nodata-home-wrap">
        <div><img :src="$Image('nodata.png')" alt=""></div>
        <div class="no-data-top">
          <div class="nodata-display">{{$t("Connect Kid's Device")}}</div>
          <!-- <div class="nodata-have">{{$t("You have not installed Famikit on your child's phone. After installation, you can reopen Famikit on this device to see the statistics of children's mobile phones.")}}</div> -->
          <div>{{$t("You have not install FamiKit on your kid's device. After installation, you can view your kid's device statistics.")}}</div>
        </div>
        <div class="no-data-bottom-title">{{$t('What should I do ?')}}</div>
        <div class="tab-wrapper">
          <!--tab section 1-->
          <div class="flex-row-start">
            <label @click="SectionTab" :class="SecTab ? 'tab-handler' : 'tab-handlers'">{{$t("Kid device is Android")}}</label>
            <label @click="SectionTabtn" :class="SecTabtn ? 'tab-handler' : 'tab-handlers'">{{$t("Kid device is Windows")}}</label>
          </div>
          <div :class="SecTab ? 'tab-content' : 'content_opacity'">
            <div class="section_size">{{$t("1. Get your kid's cell phone.")}}</div>
            <div class="section_size">{{$t('2. Visit famikit.com in browser, download and install Famikit App.')}}</div>
            <div class="section_size">{{$t("3. Open FamiKit app, sign in（ {email} ）and select kid's role.", { email: loginEmail })}}</div>
            <div class="section_size">{{$t('4. Follow the instructions in FamiKit to set permissions.')}}</div>
            <div class="section_size">{{$t('5. Refresh this page.')}} <a @click="pageRefresh" style="color:#0cc86c;text-decoration:underline;cursor:pointer;">
            {{$t('Refresh Now.')}} </a></div>
          </div>
          <!--tab section 2-->
          <div :class="SecTabtn ? 'tab-content' : 'content_opacity'">
            <div class="section_size">{{$t("1. Get your kid's PC")}}</div>
            <div class="section_size">{{$t('2. Download FamiKit android app from Google Play')}}</div>
            <div class="section_size">{{$t("3. Open FamiKit app, sign in（ {email} ）", { email: loginEmail })}}</div>
            <div class="section_size">{{$t('4. Refresh this page.')}} <a @click="pageRefresh" style="color:#0cc86c;text-decoration:underline;cursor:pointer;">
            {{$t('Refresh Now.')}} </a></div>
          </div>
        </div>
        <!-- <div class="no-data-bottom">
          <div>{{$t("1. Get your kid's device (Android or Windows).")}}</div>
          <div>{{$t('2. Download FamiKit android app from Google Play or download FamiKit windows app from famikit.com.')}}</div>
          <div>{{$t("3. Open FamiKit app, sign in（ {email} ）and select kid's role.", { email: loginEmail })}}</div>
          <div>{{$t("3. Install FamiKit on your kid's device.")}}</div>
          <div>{{$t('4. Follow the instructions in FamiKit to set permissions.')}}</div>
          <div>{{$t('5. Refresh this page to view statistics.')}} <a @click="pageRefresh" style="color:#0cc86c;text-decoration:underline;cursor:pointer;">
            {{$t('Refresh Now.')}} </a></div>
          <div>{{$t("6. 未绑定设备时可进入 Account 界面（web 版）")}}</div>
          <div>{{$t("7. 点击 Web Filter 和 Geofences 分类时弹窗显示 Comming Soon")}}</div>
        </div> -->
      </div>
      <div class="item-view-footer">{{$t('Copyright @ 2021, Famikit.com. All rights reserved.')}}</div>
    </div>
  </el-container>
</template>
<script>
export default {
  props: ['userid'],
  name: 'user',
  inject: ['rootMenu', 'reload'],
  provide: function () {
    return {
      'rootMenu': this
    }
  },
  data () {
    return {
      value: 'Kid',
      proShow: false,
      currentUser: null,
      isRefreshFailed: false,
      currentPath: 'Home',
      SecTab: true,
      SecTabtn: false,
      activeDevice: '',
      routerName: 'Home',
      VersionApk: '',
      loginEmail: 'yy.com',
      asideTable: [
        {selectIcon: 'pic_6', icon: 'pic_5', label: this.$t('Home'), path: 'Home', type: '1', proShow: false},
        {selectIcon: 'pic_12', icon: 'pic_11', label: this.$t('Sreen Time'), path: 'SreenTime', type: 'ScheduleRestriction', proShow: false},
        {selectIcon: 'pic_2', icon: 'pic_1', label: this.$t('Apps Time'), path: 'AppsTime', type: 'ScheduleRestriction', proShow: false},
        {selectIcon: 'pic_15', icon: 'pic_16', label: this.$t('Browser Histroy'), path: 'BrowserHistroy', type: 'BrowserHistory', proShow: false},
        {selectIcon: 'pic_14', icon: 'pic_13', label: this.$t('Website Filter'), path: 'WebsiteFilter', type: 'WebFilter', proShow: true},
        {selectIcon: 'pic_4', icon: 'pic_3', label: this.$t('Geofences'), path: 'Geofences', type: 'Geofences', proShow: true},
        {selectIcon: 'pic_10', icon: 'pic_9', label: this.$t('Notifications'), path: 'Notifications', type: '1', proShow: false},
        {selectIcon: 'pic_8', icon: 'pic_7', label: this.$t('My'), path: 'My', type: '1', proShow: false}
      ],
      isNoData: false,
      user: null,
      isSyncing: false,
      devices: [],
      deviceskids: [],
      beforeTimeData: 0,
      downloadApkDialog: false,
      showNewApkTips: false,
      AccountExpired: false,
      EnabledModulesData: [],
      Alldevices: null,
      RouterLists: 'Home',
      ShowMenu: false,
      proIndex: ''
    }
  },
  methods: {
    SectionTab () {
      this.SecTab = true
      this.SecTabtn = false
    },
    SectionTabtn () {
      this.SecTabtn = true
      this.SecTab = false
    },
    async getUserInfo () {
      try {
        const userInfo = await this.$http.get('MDM/GetUserInfo').catch((e) => {
          console.log('MDM/GetUserInfo', e)
        })
        if (userInfo.data.devices.length > 0) {
          this.isNoData = false
          this.user = userInfo.data
          console.log(this.user)
          this.devices = this.user.devices
          console.log(this.devices)
          this.devices.map((c) => {
            this.deviceskids.push(JSON.parse(c.userinfo))
          })
          this.deviceskids.map((c, i) => {
            let value = i
            c.value = value
          })
          // console.log(this.deviceskids)
          this.activeDevice = this.devices[0]
          // console.log(JSON.parse(this.activeDevice.userinfo))
          this.currentUser = JSON.parse(this.activeDevice.userinfo)
          // console.log(this.currentUser.NickName)
          console.log(this.activeDevice)
          this.value = this.currentUser.NickName
          this.setActiveDevice()
          this.sendDeviceInfo(true)
          // this.Refresh()
          this.$router.push({ path: this.$Demo ? `/User/Demo/Device/Home` : `/User/${this.userid}/${this.activeDevice.id}/Home`, query: { android: this.activeDevice.OS ? this.activeDevice.OS : '' } })
          // this.$router.push({ path: `/User/Demo/Device/Home` })
          // console.log(this.activeDevice.id)
        } else {
          this.loginEmail = userInfo.data.account
          this.isNoData = true
        }
      } catch (error) {
        console.log(error)
        this.$http.get('MDM/EndGetStatus')
        this.$router.push('/')
      }
    },
    async setActiveDevice (ischange) {
      console.log(`set active device to: ${this.activeDevice.id}`)
      let result = await this.$http.get(`MDM/SetActiveDevice?id=${this.activeDevice.id}`).catch((e) => {
        console.log(`get: /User/device?id=${this.activeDevice.id} failed with error: ${e}`)
      })
      console.log(result)
      if (result) {
        sessionStorage.setItem('DID', this.activeDevice.id)
        let EnabledModules = await this.$http.get(`MDM/Device/GetEnabledModules/${this.activeDevice.id}`)
        console.log(EnabledModules)
        this.EnabledModulesData = EnabledModules.data.data
        if (ischange) {
          this.$router.push({ path: this.$Demo ? `/User/Demo/Device/${this.asideTable[0].path}` : `/User/${this.userid}/${this.activeDevice.id}/${this.asideTable[0].path}`, query: { android: this.activeDevice.OS ? this.activeDevice.OS : '' } })
        } else {
          this.$router.push({ path: this.$Demo ? `/User/Demo/Device/${this.asideTable[0].path}` : `/User/${this.userid}/${this.activeDevice.id}/${this.asideTable[0].path}`, query: { android: this.activeDevice.OS ? this.activeDevice.OS : '' } })
        }
      }
    },
    // 选择孩子
    onChangeUser (index) {
      console.log(index)
      this.currentUser = this.deviceskids.find((c) => c.value === index)
      this.activeDevice = this.devices[index]
      this.setActiveDevice(true)
      this.sendDeviceInfo(true)
      // this.asideTable[0].selectIcon
      // this.Refresh()
    },
    // 路由跳转
    onClickRow (row) {
      if (this.proIndex === row.path) {
        console.log('1111111111111')
        this.$router.replace({
          path: '/refresh',
          query: {
            t: Date.now()
          }
        })
        this.$router.push({ path: `/User/${this.userid}/${this.activeDevice.id}/${row.path}`, query: { android: this.activeDevice.OS ? this.activeDevice.OS : '' } })
      } else {
        console.log('2222222222222')
        this.currentPath = row.path
        console.log(row)
        if (this.devices.length <= 0) {
          if (this.currentPath === 'My') {
            this.isNoData = false
          } else {
            this.isNoData = true
          }
        }
        // 可用模块划分
        if (this.EnabledModulesData.indexOf(row.type) !== -1 || row.type === '1') {
          this.$router.push({ path: `/User/${this.userid}/${this.activeDevice.id}/${row.path}`, query: { android: this.activeDevice.OS ? this.activeDevice.OS : '' } })
          this.Refresh()
        } else {
          this.$router.push({ path: this.$Demo ? `/User/Demo/Device/${this.currentPath}` : `/User/${this.userid}/${this.activeDevice.id}/Buy` })
        }
        // sessionStorage.setItem('rowName', row.path)
        this.ShowMenu = false
      }
      this.proIndex = row.path
    },
    connectDevice (a) {
      // this.onClickRow()
      console.log('22222222222222')
    },
    dateFormatter: function (aDate) {
      return this.$Formatter.date(aDate * 1000)
    },
    // 刷新
    async Refresh (type) {
      // console.log(type)
      if (type) {
        this.$emit('onRefresh')
        let result = await this.$http.get('MDM/Refresh')
        console.log(result)
        const currentSync = await this.$http.get('MDM/Info')
        // this.VersionApk = result.data.apkVer
        // this.downloadApkDialog = result.data.newapk ? result.data.newapk : false
        // 手机端是否有新的apk需要下载  弹框提醒
        var currentTime = currentSync.data.syncTime
        if (result.statusText === 'OK') {
          setTimeout(() => {
            this.sendDeviceInfo()
            this.$emit('updateSync', currentSync.data)
            // console.log(this.beforeTimeData.syncTime, currentTime)
            if (this.beforeTimeData.syncTime <= currentTime) {
              this.isRefreshFailed = true
              setTimeout(() => { this.isRefreshFailed = false }, 5000)
            }
          }, 10000)
        }
      } else {
        this.sendDeviceInfo()
      }
    },
    async sendDeviceInfo (type) {
      try {
        this.downloadApkDialog = false
        const result = await this.$http.get('MDM/Info')
        this.VersionApk = result.data.apkVer
        // 手机端是否有新的apk需要下载  弹框提醒
        console.log(result.data)
        if (type) {
          this.downloadApkDialog = result.data.newapk ? result.data.newapk : false
        }
        let newDate = new Date().getTime()
        // 账号是否过期弹框
        // console.log(result.data, newDate)
        if (((result.data.expireDate * 1000) - newDate) >= 0) {
          this.AccountExpired = false
        } else {
          // this.AccountExpired = true
        }
        if (this.beforeTimeData === 0) {
          this.beforeTimeData = result.data
        }
        if (this.beforeTimeData.syncTime < result.data.syncTime) {
          this.beforeTimeData = result.data
        }
        this.$emit('beforeTimeChange', this.beforeTimeData)
      } catch (e) {
        console.log(e)
      }
    },
    downloadNewVersion () {
      this.$http.get('MDM/ReqUpdate')
      this.downloadApkDialog = false
      this.showNewApkTips = false
    },
    AccountRenew () {
      this.$router.push({ path: `/User/${this.userid}/${this.activeDevice.id}/Buy` })
      this.AccountExpired = false
    },
    async onUnbind (id) {
      console.log(id)
      if (id === this.activeDevice.id) {
        this.getUserInfo()
        this.$http.get('MDM/EndGetStatus')
        this.$router.push('/')
      } else {
        const userInfo = await this.$http.get('MDM/GetUserInfo').catch((e) => {
          console.log(e)
        })
        if (userInfo) {
          this.devices = userInfo.data.devices
        }
        if (this.devices.length > 0) {
          this.activeDevice = this.devices[0]
        } else {
          this.$http.get('MDM/EndGetStatus')
          this.$router.push('/')
        }
      }
    },
    pageRefresh () {
      this.reload()
      setTimeout(() => {
        this.$message({
          message: 'The child device has not been bound yet',
          type: 'warning'
        })
      }, 1000)
    },
    SelectMenuOne () {
      this.ShowMenu = !this.ShowMenu
    }
  },
  mounted () {
    this.getUserInfo()
    this.rootMenu.$on('OnMenuOne', this.SelectMenuOne)
    this.rootMenu.$on('connectDevice', this.connectDev)
    console.log(this.$store.state.isLogined)
  },
  created () {
    console.log(this.$store.state.isLogined)
    console.log('created')
    // this.rootMenu.$on('connectDevice', this.connectDev)
    this.$on('onUnbind', this.onUnbind)
    window.addEventListener('beforeunload', e => {
      sessionStorage.setItem('routerName', this.routerName)
    })
    // if (this.$store.state.isLogined === 11) {
    //   location.reload()
    // }
  },
  watch: {
    '$route' (to, from) {
      // var RouterList = to.fullPath.split('/')
      // console.log(to, from)
      if (this.devices.length === 0 && to.name === 'Home') {
        this.onClickRow(this.asideTable[0])
      }
      // this.RouterLists = RouterList
    }
  }
}
</script>
<style lang="scss">
.tagStyle {
  padding: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user-aside-shadow{
  width:100%;
  height:100%;
  box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.1);
  .el-table__header-wrapper{
    display: none;
  }
}
  .user-aside{
    width:20%;
    .user-aside-top{
      padding:31px 20px;
      border-bottom:1px solid #ebebeb;
       .el-input--mini .el-input__inner{
        width:142px;
        height:32px;
        border-radius: 16px;
      }
    }
    .aside-table-row{
      height:60px;
      padding:0;
      border:none;
      cursor: pointer;
      .cell {
        height:100%;
        padding:0;
      }
    }
    .aside-nav-item{
      width:100%;
      height:100%;
      padding-left:25px;
      div{
        margin-left:18px;
        font-size:16px;
        font-family: 'Nunito-SemiBold';
      }
    }
    .aside-table-select{
      width:100%;
      height:100%;
      background-color:#2bcf88;
      div{
        color:#fff;
      }
    }
    .aside-table-normal{
      width:100%;
      height:100%;
      div{
        color:#333;
      }
    }
    .el-table--border::after, .el-table--group::after, .el-table::before{
      background-color: #fff;
    }
  }
  .user-main{
    background-color:#E6EEEB;
  }
  .item-view-footer{
      box-sizing: border-box;
      font-size: 14px;
      color: #738a80;
      padding-top: 3%;
    }
.shen_li {background-image: url('../../static/images/asideIcon.png'); display: block;width: 24px;height: 21px;}
.pic_1 {background-position: -0px -0px; width: 24px; height: 24px; }
.pic_2 {background-position: -24px -0px; width: 24px; height: 24px; }
.pic_3 {background-position: -48px -0px; width: 24px; height: 24px; }
.pic_4 {background-position: -72px -0px; width: 24px; height: 24px; }
.pic_5 {background-position: -96px -0px; width: 24px; height: 24px; }
.pic_6 {background-position: -120px -0px; width: 24px; height: 24px; }
.pic_7 {background-position: -144px -0px; width: 24px; height: 24px; }
.pic_8 {background-position: -168px -0px; width: 24px; height: 24px; }
.pic_9 {background-position: -192px -0px; width: 24px; height: 24px; }
.pic_10 {background-position: -216px -0px; width: 24px; height: 24px; }
.pic_11 {background-position: -240px -0px; width: 24px; height: 24px; }
.pic_12 {background-position: -264px -0px; width: 24px; height: 24px; }
.pic_13 {background-position: -288px -0px; width: 24px; height: 24px; }
.pic_14 {background-position: -312px -0px; width: 24px; height: 24px; }
.pic_15 {background-position: -360px -0px; width: 24px; height: 24px; }
.pic_16 {background-position: -337px -0px; width: 24px; height: 24px; }
.nodata-wrap{
  padding:30px;
  background-color: #E6EEEB;
  width: 100%;
}
.nodata-home-wrap{
  width:80%;
  height:100%;
  box-sizing: border-box;
   background-color: #ffffff;
    box-shadow: 4px 0px 8px 0px rgba(0, 0, 0, 0.05);
    border-radius: 20px;
    padding:5% 15% 0 15%;
    .no-data-top{
      font-size: 16px;
      color:#888888;
    }
    .no-data-bottom-title{
      font-family: 'Nunito-SemiBold';
      font-size: 22px;
      color: #333333;
      margin-top:3%;
      margin-bottom: 50px;
    }
    .no-data-bottom{
      font-family: 'Nunito-Regular';
      font-size: 16px;
      color: #333333;
      div{
        font-size: 18px;line-height: 48px;color: #333333;
        text-align: left;
      }
    }
}
.nodata-display{
  font-size: 18px;line-height: 54px;color: #333;
}
.nodata-have{
  line-height: 30px;text-align: left;
}
.user_show_Menu {
  display: none;
  width: 50%;
}
.user_hide_Menu {
  display: block;
}
.container{
  background-color: #fff;
}
.tab-handler{
  margin-right: 50px;
  font-size: 14px;
  color: #2bcf88;
  border-bottom: solid 2px #2bcf88;
  padding-bottom: 15px;
}
.tab-handlers{
  margin-right: 50px;
  font-size: 14px;
  color: #333;
  padding-bottom: 17px;
}
.tab-handler:hover{
  cursor: pointer;
}
.tab-handlers:hover{
  cursor: pointer;
}
.tab-content{
  display: block;
  text-align: left;
  margin-top: 30px;
}
.content_opacity{
  display: none;
  text-align: left;
}
.section_size{
  line-height: 30px;
  font-size: 16px;
}
@media (max-width: 1324px){
    .nodata-home-wrap {
      width: 100%;
      padding: 5% 5% 0 5%;
    }
}
@media (max-width: 1024px){
  .nodata-wrap {
    height: 100%;
  }
  .user_show_Menu {
    position: absolute;
    top: 80px;
    left: 0;
    background-color: #fff;
    display: block;
    z-index: 10;
    width: 100%;
    box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.12);
  }
  .user_hide_Menu {
    display: none;
  }
  .item-view-footer{
    padding: 3%;
  }

  .nodata-home-wrap .no-data-bottom-title {
    font-size: 24px;
  }
  .nodata-home-wrap .no-data-bottom div {
    font-size: 16px;
  }
}
@media (max-width: 580px){
  .nodata-home-wrap .no-data-bottom div {
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User.vue